import React from 'react';
import {useSelector} from 'react-redux';
import {Link} from "react-router";


// TODO Better name and generalize
export function AdminOnlyLink(props) {
  const {
    to,
    label,
    children,
  } = props;

  const text = children || label;
  const onlyShowText = useSelector((state => state.getIn(["auth", "isWarehouseOperator"], false)));

  return onlyShowText ? <span className="noLink">{text}</span> : (
    <Link to={to}>{text}</Link>
  );
}